module.exports = __webpack_public_path__ + "assets/img/image.68f10dc3.svg";